// features/ClientWrapper.tsx (Final Version)
'use client';

import { useEffect, useState, Suspense } from 'react';
import PasswordModal from './PasswordModal';
import { useSearchParams } from 'next/navigation';

// 1. Isolate the logic that uses useSearchParams in an inner component
function ClientWrapperContent({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  const searchParams = useSearchParams();
  const token = searchParams.get('token');

  // 2. If the feature is disabled, render the website immediately and stop.
  const [isVerified, setIsVerified] = useState(true);

  // Note: Checking window in the render body is okay here only because
  // isVerified defaults to true, preventing a hydration mismatch initially.
  const isPasswordProtectionEnabled =
    typeof window !== 'undefined' &&
    window.location.origin === 'https://beta.kireibd.com';

  useEffect(() => {
    if (token) {
      const storedToken = localStorage.getItem('token');
      if (!storedToken) {
        localStorage.setItem('token', token);
      }
    }

    const verified = localStorage.getItem('password_kirei') || '';
    if (verified === 'Tork') {
      setIsVerified(true);
    } else {
      setIsVerified(false);
    }
  }, [token]);

  // cross-tab sync handled in StoreProvider (after Redux Provider)

  if (isPasswordProtectionEnabled && !isVerified) {
    return <PasswordModal setIsVerified={setIsVerified} />;
  } else {
    return <>{children}</>;
  }
}

// 3. Export the wrapper which provides the Suspense boundary
export default function ClientWrapper(
  props: Readonly<{ children: React.ReactNode }>
) {
  return (
    // The fallback UI is shown while the search params are being read.
    // passing null is standard for logic wrappers, but you can use a loader if preferred.
    <Suspense fallback={null}>
      <ClientWrapperContent {...props} />
    </Suspense>
  );
}
